
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface PackageCardProps {
  type: 'silver' | 'gold';
  title: string;
  price: string;
  features: string[];
  icon: React.ReactNode;
  isPopular?: boolean;
  onSelect: (packageType: 'silver' | 'gold') => void;
}

const PackageCard = ({ 
  type, 
  title, 
  price, 
  features, 
  icon, 
  isPopular = false,
  onSelect 
}: PackageCardProps) => {
  return (
    <div className={`bg-white rounded-2xl shadow-soft hover:shadow-elevated transition-all duration-300 overflow-hidden ${isPopular ? 'border-2 border-brand-yellow' : ''}`}>
      {isPopular && (
        <div className="relative">
          <div className="absolute -top-5 right-0 left-0 text-center">
            <span className="bg-brand-yellow text-brand-blue text-xs font-bold px-3 py-1 rounded-full">MOST POPULAR</span>
          </div>
        </div>
      )}
      <div className={`${isPopular ? 'bg-amber-50 border-b border-amber-100' : 'bg-gray-100 border-b border-gray-200'} p-6`}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-2xl font-bold text-brand-blue">{title}</h3>
          {icon}
        </div>
        <div className="flex items-baseline">
          <span className="text-3xl font-bold text-brand-blue">{price}</span>
          <span className="text-gray-500 ml-1">one-time</span>
        </div>
      </div>
      
      <div className="p-6 space-y-4">
        <div className="space-y-4">
          {features.map((feature, index) => (
            <div key={index} className="flex items-start">
              <CheckCircle className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
              <p className="text-gray-700" dangerouslySetInnerHTML={{ __html: feature }} />
            </div>
          ))}
        </div>
        
        <Button 
          onClick={() => onSelect(type)}
          className={`w-full mt-6 ${isPopular 
            ? 'bg-brand-yellow text-brand-blue hover:bg-amber-400' 
            : 'bg-brand-blue text-white hover:bg-brand-blue/90'} font-semibold py-2 rounded-lg`}
        >
          Select {title}
          <ArrowRight className="ml-2 h-5 w-5" />
        </Button>
      </div>
    </div>
  );
};

export default PackageCard;
